import { FrontWebPodcastProgramModel} from "../../../generated";
import ListCss from "../List.module.scss";
import  { ProgramBox} from "../../Item/Podcast/ProgramBox";
import {useIsSafari} from "../../../contexts/useIsSafari";

export const ProgramBoxList = (props : {
    items: FrontWebPodcastProgramModel[],
    className?: string
}) => {
    const isSafari = useIsSafari();
    return <ul className={`d-flex justify-content-start flex-wrap ${ListCss.UlBox} ${props.className ?? ""}`}>
        {props.items.map((item, k) => (
            <li key={k} className={`${ListCss.LiBox} ${isSafari.noGap ? ListCss.LiBoxSafari : ""}`}>
                <ProgramBox program={item}/>
            </li>)
        )}</ul>
}
